import { jsx as _jsx } from "react/jsx-runtime";
import { FixedSizeList } from "react-window";
import InfiniteLoader from "react-window-infinite-loader";
const DropdownListPageable = ({ heightList = 300, heightItem = 40, isLoading, isFetching, hasNextPage, data, fetchNextPage, placeholderComponent: Placeholder, loadingComponent: Loading, itemComponent: ItemList, }) => {
    const totalItems = data?.length;
    if (isLoading)
        return Loading;
    if (!totalItems)
        return Placeholder;
    const itemCount = hasNextPage ? data.length + 1 : data.length;
    const loadMoreItems = isFetching ? () => { } : fetchNextPage;
    const isItemLoaded = (index) => !hasNextPage || index < data.length;
    const Row = ({ index, style }) => {
        const item = data[index];
        const content = isItemLoaded(index) ? ItemList(item, index) : Loading;
        return _jsx("div", { style: style, children: content });
    };
    return (_jsx(InfiniteLoader, { isItemLoaded: isItemLoaded, itemCount: itemCount, loadMoreItems: loadMoreItems, children: ({ onItemsRendered, ref }) => (_jsx(FixedSizeList, { className: "scrollBar", itemCount: itemCount, onItemsRendered: onItemsRendered, ref: ref, height: heightList, itemSize: heightItem, width: "100%", children: Row })) }));
};
export default DropdownListPageable;
